import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const PerPageSelector = styled.div`
  height: 30px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 3px;
  cursor: ${props => props.selected ? 'default' : 'pointer'};
  background: ${props => props.selected ? '#e8e8e8' : 'white'};
  color: ${props => props.selected ? '#b4b5b6' : '#444'};
  &:hover {
    color: ${props => props.selected ? '#b4b5b6' : '#b4b5b6'};
    background: ${props => props.selected ? '#e8e8e8' : '#dbdbdc'};
  }
`
const PerPageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 7px;
`
const TotalPages = styled(PerPageSelector)`
  cursor: default;
`

const PerPage = ({ totalRecords, perPage, changePerPage }) => {
  const shownPageSelectors = [
    10,
    totalRecords > 10 ? 20 : null,
    totalRecords > 20 ? 50 : null,
    totalRecords > 50 ? 100 : null
  ].filter(selector => selector) // Remove nulls from this array
  const perPageSelectors = shownPageSelectors.map((selector, i) => {
    return (
      <PerPageSelector
        key={`${selector}-per-page`}
        selected={perPage === selector || i === 0 && shownPageSelectors.length === 1} // Show 10 per page selected if it is the only one available - solves issue where the users selects 20 per page and switches to a tab with < 20 records
        onClick={() => changePerPage(selector)}
      >
        {selector}
      </PerPageSelector>
    )
  })
  return (
    <PerPageContainer>
      Per page
      {perPageSelectors}
      | Total
      <TotalPages selected>
        {totalRecords}
      </TotalPages>
    </PerPageContainer>
  )
}

PerPage.displayName = 'PerPage'

PerPage.propTypes = {
  changePerPage: PropTypes.func.isRequired,
  perPage: PropTypes.number.isRequired,
  totalRecords: PropTypes.number.isRequired
}

export default PerPage
